// reducers/products.reducer.ts
import { createReducer, on } from '@ngrx/store';

import {
  ChangeItemProcessStatus,
  loadCourseItemFullDetails,
} from './course-items.actions';
import { CourseItemState } from './course-items.models';

// export interface CourseHeirarchyState extends CourseHeirarchyModelBase, EntityState<CourseHierarchyItem> {}
// extends EntityState<ProductItem> {

// export const courseAdapter = createEntityAdapter<ProductItem>();
// export const courseHeirarchyAdapter = createEntityAdapter<CourseHierarchyItem>();

const initialState: CourseItemState = {
  currentCourseItem: null,
  CourseItemsProcess: [],
};

export const courseItemReducer = createReducer(
  initialState,

  on(loadCourseItemFullDetails.success, (state, { loadedItem }) => {
    console.log('loadedItem', loadedItem);

    return {
      ...state,
      currentCourseItem: loadedItem,
    };
  }),

  // Generic Item Status Update
  on(ChangeItemProcessStatus, (state, { statusChange, error }) => {
    console.log('statusChange', statusChange);
    console.log('error', error);

    const { itemId, itemType, status } = statusChange;

    let itemStatusUpdateProcess = state.CourseItemsProcess.find(
      (proc) => proc.id == itemId && proc.itemType == itemType
    );

    if (!itemStatusUpdateProcess) {
      return {
        ...state,
        CourseItemsProcess: [
          ...state.CourseItemsProcess,
          {
            id: itemId,
            itemType,
            status: status,
            message: 'Updating Status',
            error: error,
          },
        ],
      };
    } else {
      return {
        ...state,
        CourseItemsProcess: [
          ...state.CourseItemsProcess.filter(
            (proc) => proc.id != itemId || proc.itemType != itemType
          ),
          {
            id: itemId,
            itemType,
            status: status,
            message: 'Updaing Status',
            error: error,
          },
        ],
      };
    }
  })
);
